"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Pagination = exports.Carousel = exports.Articles = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  maxWidth: 970,
  margin: 'auto',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(20)
  }
}));
const Articles = exports.Articles = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridGap: theme.spacing(6),
  gridTemplateColumns: '1fr',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    gridGap: theme.spacing(10, 6),
    gridTemplateColumns: '1fr 1fr 1fr',
    marginBottom: theme.spacing(10)
  }
}));
const Pagination = exports.Pagination = (0, _mui.styled)(_presentationComponents.Pagination)(({
  theme
}) => ({
  margin: 'auto',
  maxWidth: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 360
  }
}));
const Carousel = exports.Carousel = (0, _mui.styled)(_presentationComponents.EditorialCarousel)(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(0, -12)
  }
}));
